
import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'proposals-progress-bar',
  imports: [],
  templateUrl: './proposals-progress-bar.component.html',
  styleUrl: './proposals-progress-bar.component.scss'
})
export class ProposalsProgressBarComponent implements OnChanges {
  @Input() status: string = '';
  progress: number = 0;
  displayStatus: string = '';

  public statusMap: { [key: string]: number } = {
    'SALES': 1,
    'OVERDISCOUNT_APPROVAL': 2,
    'TECH_APPROVAL': 3,
    'SALES_OVERALL_CHECK': 4,
    'PENDING_CLIENT': 5,
    'ACCEPTED_/_NOT_ACCEPTED': 6
  };

  get statusKeys(): string[] {
    return Object.keys(this.statusMap);
  }

  ngOnChanges(): void {
    if (this.status === 'ACCEPTED' || this.status === 'NOT_ACCEPTED') {
      this.displayStatus = 'ACCEPTED_/_NOT_ACCEPTED';
      this.progress = this.statusMap['ACCEPTED_/_NOT_ACCEPTED'] * 20;
    } else {
      this.displayStatus = this.status;
      this.progress = (this.statusMap[this.status] || 0) * 20;
    }
  }

  replaceUnderscoreWithSpace(keyStatus: string | null): string {
    if (!keyStatus) return '';
    return keyStatus.replace(/_/g, ' ');
  }
}
